"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPlus = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconPlus = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("rect", {
  x: 10.5,
  y: 1,
  width: 3,
  height: 22,
  rx: 1
}), /*#__PURE__*/_react.default.createElement("rect", {
  transform: "rotate(-90 12 12)",
  x: 10.5,
  y: 1.5,
  width: 3,
  height: 21,
  rx: 1
})));
exports.IconPlus = IconPlus;
//# sourceMappingURL=IconPlus.js.map